/**
 * Login-history analytics.
 */
import React from "react";
import { Icon } from '@iconify/react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import VText from "form/VText";
import BTable from 'components/BTable';
import VButton from 'form/VButton';
import { useAsterController } from 'context';
import { actionLoginHistList } from 'context/action';
import BGPagination from 'components/BGPagination';
import { getFormatDate, getShortTime } from 'utils/date';
import BPdfExporter from 'components/BPdfExporter';

/**
 * Paginated table of learner login events.
 */
const AnalysisLog = () => {

  const { t, i18n } = useTranslation('common');

  const [controller, dispatch] = useAsterController();
  const { loginHists, loadedDashboard, loadedLoginHistList } = controller;
  const loading = !loadedDashboard || !loadedLoginHistList;

  const handlePageChange = (page, pageSize) => actionLoginHistList(dispatch, { page, page_size: pageSize });

  const columns = [
    {
      name: <VText>{t('Date')}</VText>,
      selector: row => row.id,
      cell: rw => <VText>{getFormatDate(rw.date, i18n.language)} - {getShortTime(rw.date)}</VText>
    },
    {
      name: <VText>{t('Device')}</VText>,
      selector: row => row.device,
      cell: rw => <VText>{rw.device}</VText>
    },
    {
      name: <VText>{t('IP Address')}</VText>,
      selector: row => row.ip_address,
      cell: rw => <VText>{rw.ip_address}</VText>
    },
    {
      name: <VText>{t('Browser')}</VText>,
      selector: row => row.browser,
      cell: rw => <VText>{rw.browser}</VText>
    }
  ];

  return <>

    <Grid container spacing={6} className="mt-6">
      <Grid item sm={12} md={4} className="flex">
        <VText className="text-2xl">{t("Logs history")}</VText>
      </Grid>
      <Grid item sm={12} md={8} className="flex justify-center md:justify-end flex-wrap items-center">
        <VButton variant="text" color="secondary" className="text-sm normal-case">
          <Icon icon="akar-icons:circle-check" />&nbsp;{t("All status")}
        </VButton>
        <VButton variant="text" color="secondary" className="text-sm ml-2 normal-case">
          <Icon icon="ant-design:filter-filled" />&nbsp;{t('Filter')}
        </VButton>
        <VButton variant="text" color="secondary" className="text-sm ml-2 normal-case">
          <Icon icon="bx:sort" />&nbsp;{t('Sort')}
        </VButton>

        <BPdfExporter
          filename={`${t("Logs history")}.pdf`}
          title={t("Logs history")}
          columns={columns}
          rows={loginHists.data}
        />

      </Grid>
    </Grid>

    <BTable
      columns={columns}
      data={loginHists.data}
      total={loginHists.total}
      loading={loading}
    />

    <BGPagination
      handlePageChange={handlePageChange}
      total={loginHists.total}
      initPage={loginHists.page}
      initSize={loginHists.page_size}
    />
  </>;
};

export default AnalysisLog;